import React from "react";
import { useDispatch, useSelector } from "react-redux";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import { IconButton, Tooltip } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import secureLocalStorage from "react-secure-storage";
import Typography from "@mui/material/Typography";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { approveNewIndividualInvestment } from "../../actions/newIndividualInvestment";
import { deleteIndividualInvestment } from "../../actions/newIndividualInvestment";
import { Helmet } from "react-helmet-async";
import { message, Popconfirm } from "antd";
const columns = [
  { id: "code", label: "Code", minWidth: 100 },
  { id: "investment_type", label: "Investment type", minWidth: 200 },
  {
    id: "regulator",
    label: "Regulator",
    minWidth: 170,
    align: "right",
  },
  {
    id: "cost",
    label: "Cost",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "rate",
    label: "Rate",
    minWidth: 170,
    align: "right",
  },
  {
    id: "year_days",
    label: "Year days",
    minWidth: 170,
    align: "right",
  },
  {
    id: "purchase_date",
    label: "Purchase date",
    minWidth: 170,
    align: "right",
  },
  {
    id: "maturity_date",
    label: "Maturity date",
    minWidth: 170,
    align: "right",
  },
];
function createData(
  id,
  code,
  investment_type,
  regulator,
  cost,
  rate,
  year_days,
  purchase_date,
  maturity_date
) {
  return {
    id,
    code,
    investment_type,
    regulator,
    cost,
    rate,
    year_days,
    purchase_date,
    maturity_date,
  };
}
export default function CustomersApproval() {
  const [page] = React.useState(0);
  const [rowsPerPage] = React.useState(10);
  const [success] = React.useState("");

  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const newInvestments = useSelector((state) => state.newIndividualInvestments);

  const dispatch = useDispatch();

  const rows = newInvestments.map((data) =>
    createData(
      data._id,
      data.code,
      data.investment_type,
      data.regulator,
      data.cost,
      data.rate,
      data.year_days,
      moment(data.purchase_date).format("DD-MM-YYYY"),
      moment(data.maturity_date).format("DD-MM-YYYY")
    )
  );
  function approveInvestment(id) {
    dispatch(
      approveNewIndividualInvestment(id, {
        approved: "true",
        approved_by: user.results.firstName + " " + user.results.lastName,
      })
    );
  }
  function deleteNewInvestment(id) {
    dispatch(deleteIndividualInvestment(id));
  }
  return (
    <div style={{ width: "100%" }}>
      <Helmet title="Approvals | Portfolio Manager" />
      <Typography variant="h6">
        {rows.length} Pending investment for approval
      </Typography>
      <TableContainer sx={{ maxHeight: 540 }}>
        <Table
          size="small"
          stickyHeader
          aria-label="sticky table"
          style={{ backgroundColor: "#FFF" }}
          sx={{
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,
            },
          }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    top: 0,
                    minWidth: column.minWidth,
                    backgroundColor: "#ccc",
                    color: "#000",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell style={{ backgroundColor: "#ccc", color: "#000" }}>
                ACTIONS
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                    <TableCell
                      style={{
                        backgroundColor: "#ccc",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      align="center"
                    >
                      <Popconfirm
                        title="Confirm Approval?"
                        onCancel={() => {
                          message.info("Investment was not approved");
                        }}
                        okText="Yes"
                        onConfirm={() => approveInvestment(row.id)}
                      >
                        <Tooltip title="approve investment">
                          <IconButton
                            style={{ border: "1px solid #000" }}
                            size="small"
                            disabled={success ? true : false}
                          >
                            <CheckOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Popconfirm>
                      <Popconfirm
                        title="Deleting confirmation?"
                        onCancel={() => {
                          message.info("Investment was not approved");
                        }}
                        okText="Yes"
                        onConfirm={() => deleteNewInvestment(row.id)}
                      >
                        <Tooltip title="delete">
                          <IconButton
                            style={{ border: "1px solid #000" }}
                            size="small"
                          >
                            <DeleteOutlineOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Popconfirm>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
